var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EDF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.5v-2a4 4 0 00-4-4h-8a4 4 0 00-4 4v2m12-14a4 4 0 11-8 0 4 4 0 018 0z",
    stroke: "#476FF2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NCA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHk9IjAuNSIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiByeD0iMjIiIGZpbGw9IiNFREYxRkYiIC8+CiAgICA8cGF0aAogICAgICAgIGQ9Ik0zMCAzMS41VjI5LjVDMzAgMjguNDM5MSAyOS41Nzg2IDI3LjQyMTcgMjguODI4NCAyNi42NzE2QzI4LjA3ODMgMjUuOTIxNCAyNy4wNjA5IDI1LjUgMjYgMjUuNUgxOEMxNi45MzkxIDI1LjUgMTUuOTIxNyAyNS45MjE0IDE1LjE3MTYgMjYuNjcxNkMxNC40MjE0IDI3LjQyMTcgMTQgMjguNDM5MSAxNCAyOS41VjMxLjVNMjYgMTcuNUMyNiAxOS43MDkxIDI0LjIwOTEgMjEuNSAyMiAyMS41QzE5Ljc5MDkgMjEuNSAxOCAxOS43MDkxIDE4IDE3LjVDMTggMTUuMjkwOSAxOS43OTA5IDEzLjUgMjIgMTMuNUMyNC4yMDkxIDEzLjUgMjYgMTUuMjkwOSAyNiAxNy41WiIKICAgICAgICBzdHJva2U9IiM0NzZGRjIiIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";
export { SvgClient as ReactComponent };